import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useLazyQuery } from '@apollo/react-hooks';
import { RetroDiscountsQuery, RetroDiscountsQueryVariables } from './__generated__/RetroDiscountsQuery';

export const RETRO_DISCOUNTS_QUERY = gql`
  query RetroDiscountsQuery($campaignId: ID!) {
    retroDiscounts(campaignId: $campaignId) {
      article {
        id
        title
        campaignId
      }
      costs {
        date
        clicks
        spent
        discountSpent
      }
      discounts {
        date
        discountPercent
        discountType
      }
    }
  }
`;

export const useRetroDiscountsLazyQuery = () => {
  return useLazyQuery<RetroDiscountsQuery, RetroDiscountsQueryVariables>(RETRO_DISCOUNTS_QUERY, {
    client: kmsClient,
    fetchPolicy: 'no-cache'
  });
};
